import { ActionTypes } from "../../constants/ActionTypes";

export const onGetCompanyName = (companyName: string) => {
  return {
    type: ActionTypes.GET_Company_Name,
    companyName,
  };
};

export const fetchCompanyNameSuccess = (companyName: string) => {
  return {
    type: ActionTypes.FETCH_GET_Company_Name_SUCCESS,
    payload: companyName,
  };
};
